import { render, staticRenderFns } from "./main-media.vue?vue&type=template&id=039e2410&scoped=true"
import script from "./main-media.vue?vue&type=script&lang=js"
export * from "./main-media.vue?vue&type=script&lang=js"
import style0 from "./main-media.vue?vue&type=style&index=0&id=039e2410&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "039e2410",
  null
  
)

export default component.exports